import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { GeneralService } from '../services/general.service';
import { DataService } from '../services/data.service';
@Injectable()
export class BlobErrorInterceptor implements HttpInterceptor {

  constructor(private generalService : GeneralService,public dataService: DataService,
  ) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      mergeMap(event => {
        //console.log("event=============",event);
        let stringify = JSON.stringify(event);
        if (event instanceof HttpResponse && event.status === 204) {
         
          this.dataService.logFrontEndError(stringify).subscribe();
          this.generalService.showToasterErrorMessage('Server returned an invalid file type');
          return of(event);
        }
    
        if (event instanceof HttpResponse && event.body && event.body== null) {
          this.dataService.logFrontEndError(stringify).subscribe();
          this.generalService.showToasterErrorMessage('Server returned an invalid file type');
          return of(event);
        }

        if (event instanceof HttpResponse && event.status >= 200 && event.status < 300) {
          return of(event);
        }
        return of(event);
      }),
      mergeMap(event => {
        // Intercept error responses with Blob bodies
        if (event instanceof HttpErrorResponse && event.error instanceof Blob) {
          return new Observable<HttpEvent<any>>(observer => {
            const reader = new FileReader();
            reader.onload = (e: any) => {
              try {
                const error = JSON.parse(e.target.result);
                observer.error(new HttpErrorResponse({
                  error,
                  headers: event.headers,
                  status: event.status,
                  statusText: event.statusText,
                  url: event.url || undefined
                }));
              } catch (err) {
                this.dataService.logFrontEndError(err).subscribe();
                observer.error(event); // Re-throw original error if it's not JSON
              }
            };
            //reader.readAsText(event.error);
          });
        }
        return of(event);
      })
    );
  }
}